<template>
  <div class="my-12 py-12">
    <v-row no-gutters justify="center">
      <v-col cols="12" lg="11" sm="11">
        <v-list subheader two-line>
          <v-row dense justify="center" class="my-0 py-0">
            <v-col cols="auto">
              <h3>
                Application install state :
                <v-chip small label dark :color="accessToken ? 'green' : 'red'">
                  {{ accessToken ? "YES" : "NO" }}
                </v-chip>
              </h3>
            </v-col>
          </v-row>
          <v-divider inset class="mt-5"></v-divider>
          <v-subheader inset>Store installation key : </v-subheader>

          <v-list-item>
            <v-list-item-avatar size="40">
              <v-icon class="grey darken-1" dark size="30">
                mdi-shield-lock
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-text-field
                v-if="$store.state.shopify.show_btn"
                outlined
                hide-details
                readonly
                :value="`${SHOPIFY_DOMAIN}${key}`"
                single-line
              >
                template
              </v-text-field>
            </v-list-item-content>

            <v-list-item-action>
              <v-tooltip color="black" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab dark small v-on="on" @click="generateNewKey">
                    <v-icon size="25">mdi-shield-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Generate new key</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
          <v-row justify="center">
            <v-col cols="auto">
              <v-btn text outlined @click="copyURL"> copy </v-btn>
            </v-col>
          </v-row>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { IS_PRODUCTION, SHOPIFY_DOMAIN } from "@/env";
export default {
  name: "shopify_installation_key",
  data: () => ({
    IS_PRODUCTION,
    SHOPIFY_DOMAIN,
  }),
  computed: {
    key() {
      const data = this.$store.state.shopify.credentials.install_hmac;
      return data;
    },
    shop() {
      const data = this.$store.state.shopify.shop;
      return data;
    },
    accessToken() {
      const data = this.$store.state.shopify.accessToken;
      return data;
    },
  },
  created() {},
  methods: {
    async copyURL() {
      try {
        const url = `${SHOPIFY_DOMAIN}Install?key=${this.key}`;
        await navigator.clipboard.writeText(url);
        this.$store.dispatch("setSnackbar", {
          text: `link copy`,
          color: "info",
          timeout: 2000,
        });
      } catch ($e) {
        this.$store.dispatch("setSnackbar", {
          text: `error in copy the link`,
          color: "error",
          timeout: 2000,
        });
      }
    },
    generateNewKey() {
      this.$store
        .dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: `Generate new key for the shop : "${this.shop}"`,
        })
        .then((confirmation) => {
          this.$store
            .dispatch("GENERATE_NEW_INSTALL_KEY", { shop: this.shop })
            .then((r) => {
              this.$store.dispatch("setSnackbar", {
                text: `Generate new install key`,
                color: "success",
                timeout: 4000,
              });
            })
            .catch((err) => {
              console.log(err);
              this.$store.dispatch("setSnackbar", {
                text: `error in generate key`,
                color: "error",
                timeout: 4000,
              });
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
